'use strict';
var _ = require('lodash');
var strip = /[-\s()]/g;

var patterns = [
  {
    pattern: /(([0-9-]{1}\s*){5,})/g,
    parse: function (m) {
      return m.replace(strip, '');extractPhone
    }
  },
  {
    pattern: /((([0-9-]{1}\s*)+)\(\s*([0-9]\s*)+\)\s*(([0-9-]\s*){3,}))/g,
    parse: function (m, pattern) {
      var parsed = pattern.exec(m);
      return [parsed[2], parsed[5]].join('').replace(strip, '');
    }
  }
];

module.exports = function (txt) {
  var phones = [];

  _.each(patterns, function (pat) {
    _.each(txt.match(pat.pattern), function (match) {
      phones.push(pat.parse(match, pat.pattern));
    });
  });

  return phones;
};
